import { useSelector } from 'react-redux';
import { RootState, store } from '../redux/store';
import cs from './cs.json';
import en from './en.json';

type TranslationKeys = keyof typeof cs;
type TranslationsType = typeof cs & {
  [key: string]: string;
};

const getLangData = (): TranslationsType => {
  const state = store.getState();
  const lang = state.user.lang || 'cs';
  return (lang === 'en' ? en : cs) as TranslationsType;
};

export const t = (key: TranslationKeys | string): string => {
  const langData = getLangData();
  return langData[key] || key;
};

export const useT = () => {
  const lang = useSelector((state: RootState) => state.user.lang || 'cs');
  const langData = (lang === 'en' ? en : cs) as TranslationsType;
  return (key: TranslationKeys | string): string => langData[key] || key;
};